export default "__VITE_ASSET__CachBHor__"